module.exports = __webpack_public_path__ + "static/media/HQ-icon.ba9fdcf6.svg";